import statuscss from "../css/statusindicator.module.css";


function StatusIndicator({ status ,label=null}) {

  const getClass = () => {
    const lowerStatus = status.toLowerCase();

    if (lowerStatus.includes("red")) return statuscss.fail;
    if (lowerStatus.includes("success")) return statuscss.success;
    if (lowerStatus.includes("approved")) return statuscss.success;
    if (lowerStatus.includes("failed")) return statuscss.fail;
    if (lowerStatus.includes("in progress")) return statuscss.inprogress;
    if (lowerStatus.includes("unresolved")) return statuscss.inprogress;
    if (lowerStatus.includes("on hold")) return statuscss.onhold;
    if (lowerStatus.includes("pending")) return statuscss.pending;
    if (lowerStatus.includes("completed")) return statuscss.success;
    if (lowerStatus.includes("resolved")) return statuscss.success;
    if (lowerStatus.includes("submitted")) return statuscss.submitted;
    if (lowerStatus.includes("closed")) return statuscss.submitted;
    if (lowerStatus.includes("over due")) return statuscss.overdue;
    if (lowerStatus.includes("open")) return statuscss.open;
    if (lowerStatus.includes("not started")) return statuscss.open;
    if (lowerStatus.includes("returned")) return statuscss.returned;
  
    return 'default';
  };

  return (
    <div className={`${statuscss.status_indicator} ${getClass()}`}>
      {`${label?label:status}`}
    </div>
  );
}

export default StatusIndicator;